import React from "react";
import styled from "styled-components";
import ModalWrapper from "./ModalWrapper.js";
import QR from "./QR.js";
import QRText from "./QRText.js";
import QRDesc from "./QRDesc.js";
import CloseIcon from "./CloseIcon";
import HelpText from "./HelpText";
import HelpLogo from "./HelpLogo";
import AlphaLogo from "../../components/AlphaLogo.js";
import AlphaLogoSVG from "../../components/AlphaLogoSVG.js";
import { Link } from "react-router-dom";
import Header from "./Header.js";

const Modal = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  border-radius: 3px;
  height: 100%;
  width: 100%;
`;

const modal = ({
  show,
  close,
  redirectQR,
  resourceURL,
  theme,
  christmasTheme,
}) => {
  function closeModal() {
    close();
  }

  return (
    <ModalWrapper show={show}>
      <Modal>
        <Header>
          <CloseIcon onClick={closeModal}>
            <svg
              width="27"
              height="27"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.6568 6.34314L12 12M12 12L6.34314 17.6568M12 12L17.6568 17.6568M12 12L6.34314 6.34314"
                stroke="black"
                strokeWidth="2"
              />
            </svg>
          </CloseIcon>

          <HelpText>
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to={{ pathname: "https://alphaar.io/how-it-works.html" }}
              target="_blank"
            >
              <HelpLogo>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="black"
                    strokeWidth="2"
                  />
                  <path
                    d="M8.68835 9.79889C8.68835 7.88508 10.2729 6.49829 12.0348 6.49829C13.7966 6.49829 15.3094 7.88508 15.3094 9.79889C15.3094 11.2724 14.0913 11.7439 12.9714 12.9817C12.3338 13.6865 12.0348 14.7892 12.0348 15.2804M12.0348 16.5V18.5"
                    stroke="black"
                    strokeWidth="2"
                  />
                </svg>
              </HelpLogo>
              How it works
            </Link>
          </HelpText>
        </Header>
        <QR>
          <img src={redirectQR.url} height="180px" width="180px"></img>
        </QR>
        <QRText>
          Scan this QR code with <br />
          your phone camera
        </QRText>
        <QRDesc>
          You can also open{" "}
          <Link
            style={{ textDecoration: "underline", color: "black" }}
            to={{ pathname: resourceURL }}
            target="_blank"
          >
            {" "}
            {resourceURL}
          </Link>{" "}
          in your phone browser
        </QRDesc>
      </Modal>
      <AlphaLogo
        show={theme === "vivaTheme" ? (christmasTheme ? false : true) : false}
        style={{
          top: "unset",
          bottom: "5%",
          right: "unset",
        }}
      >
        <Link
          style={{ textDecoration: "none" }}
          to={{ pathname: "https://alphaar.io" }}
          target="_blank"
        >
          <AlphaLogoSVG
            viewBox="0 0 106 24"
            style={{
              height: "35px",
              width: "200px",
            }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M71.1599 8.10637C71.1599 4.28499 71.1599 2.3743 72.347 1.18715C73.5341 0 75.4448 0 79.2662 0H97.0535C100.875 0 102.786 0 103.973 1.18715C105.16 2.3743 105.16 4.28499 105.16 8.10637V15.8936C105.16 19.715 105.16 21.6257 103.973 22.8128C102.786 24 100.875 24 97.0535 24H79.2662C75.4448 24 73.5341 24 72.347 22.8128C71.1599 21.6257 71.1599 19.715 71.1599 15.8936V8.10637ZM79.6776 17.4297L80.3656 15.4777H85.0376L85.7256 17.4297H88.2376L83.9656 6.06974H81.5016L77.2296 17.4297H79.6776ZM82.7176 8.94974L84.2856 13.3817H81.1176L82.6856 8.94974H82.7176ZM98.8071 17.4297L96.3271 12.8697C97.6551 12.3257 98.3431 11.1257 98.3431 9.62174C98.3431 7.54174 97.0311 6.06974 94.5511 6.06974H89.3991V17.4297H91.7351V13.1257H93.9751L96.1031 17.4297H98.8071ZM96.0071 9.62174C96.0071 10.4537 95.5271 10.9817 94.5511 10.9817H91.7351V8.21374H94.5511C95.5271 8.21374 96.0071 8.78974 96.0071 9.62174ZM21.4222 18.6743V0.674316H18.0142V18.6743H21.4222ZM3.672 18.6743L4.704 15.7463H11.712L12.744 18.6743H16.512L10.104 1.63432H6.408L0 18.6743H3.672ZM8.232 5.95432L10.584 12.6023H5.832L8.184 5.95432H8.232ZM31.6813 18.9623C29.9053 18.9623 28.6093 18.1943 27.9613 17.3303V23.6663H24.5533V6.09832H27.6973V7.63432C28.4893 6.48232 29.9053 5.81032 31.6813 5.81032C35.3293 5.81032 37.4653 8.73832 37.4653 12.3863C37.4653 16.0343 35.3293 18.9623 31.6813 18.9623ZM30.9613 8.81032C29.0653 8.81032 27.8653 10.3463 27.8653 12.3863C27.8653 14.4263 29.0653 15.9623 30.9613 15.9623C32.8573 15.9623 34.0573 14.4263 34.0573 12.3863C34.0573 10.3463 32.8573 8.81032 30.9613 8.81032ZM43.1957 0.674316H39.7877V18.6743H43.1957V11.4983C43.1957 9.77032 44.1077 8.73832 45.7637 8.73832C47.2757 8.73832 47.8997 9.74632 47.8997 11.2103V18.6743H51.3077V10.8263C51.3077 7.82632 49.6997 5.81032 46.6757 5.81032C45.0437 5.81032 43.8437 6.38632 43.1957 7.25032V0.674316ZM63.2949 7.63432V6.09832H66.4389V18.6743H63.2949V17.1383C62.5029 18.2903 61.0869 18.9623 59.3109 18.9623C55.6629 18.9623 53.5269 16.0343 53.5269 12.3863C53.5269 8.73832 55.6629 5.81032 59.3109 5.81032C61.0869 5.81032 62.5029 6.48232 63.2949 7.63432ZM60.0309 15.9623C61.9269 15.9623 63.1269 14.4263 63.1269 12.3863C63.1269 10.3463 61.9269 8.81032 60.0309 8.81032C58.1349 8.81032 56.9349 10.3463 56.9349 12.3863C56.9349 14.4263 58.1349 15.9623 60.0309 15.9623Z"
              fill="#0A083A"
            />
          </AlphaLogoSVG>
        </Link>
      </AlphaLogo>
    </ModalWrapper>
  );
};

export default modal;
